'use strict';
module.exports = function isUploadableAttachment(uri) {
	return !!uri && /^data:[a-z]+\/[^;]+;base64,[A-z0-9=+/]+$/.test(uri);
};
